module.exports = __webpack_public_path__ + "static/media/cloudsmith.0924c63c.svg";